module.exports = __webpack_public_path__ + "img/QR-code.8a3ad972.png";